<template>
<div class="nav-but">
    <div class="header">
        <a href="./"><img class="logo-img" src="../assets/logo.png" alt="ヘッダーロゴ"></a>
        <nav>
            <ul class="navi-list">
                <li class="navi-item">
                    <router-link to="/">
                        <div class="navi-item-text">
                            <p class="navi-item-text-main">TOP</p>
                            <p class="navi-item-text-sub">トップ</p>
                        </div>
                    </router-link>
                </li>
                <li class="navi-item">
                    <router-link to="/about">
                        <div class="navi-item-text">
                            <p class="navi-item-text-main">ABOUT</p>
                            <p class="navi-item-text-sub">セルフエステエンリケについて</p>
                        </div>
                    </router-link>
                </li>
                <li class="navi-item">
                    <router-link to="/menu">
                        <div class="navi-item-text">
                            <p class="navi-item-text-main">MENU</p>
                            <p class="navi-item-text-sub">料金プラン</p>
                        </div>
                    </router-link>
                </li>
                <li class="navi-item">
                    <router-link to="/salonlist">
                        <div class="navi-item-text">
                            <p class="navi-item-text-main">SHOP</p>
                            <p class="navi-item-text-sub">店舗一覧</p>
                        </div>
                    </router-link>
                </li>
                <li class="navi-item">
                    <router-link to="/faq">
                        <div class="navi-item-text">
                            <p class="navi-item-text-main">FAQ</p>
                            <p class="navi-item-text-sub">よくある質問</p>
                        </div>
                    </router-link>
                </li>
            </ul>
        </nav>
    
    </div>
    <div class="bottom-button">
        <div class="login-button">
            <a class="login-link" href="https://selfesthe.enrike.jp/mypage/login.php">会員様ログイン</a>
        </div>
        <div class="booking-button">
            <router-link to="/salonlist">
           <p class="booking-link">予約</p> 
            </router-link>
        </div>
    </div>

</div>
</template>

<script>
export default {
  name: 'NavigationBar',
}
</script>

<style scoped>
    .w-100-per{
        width: 100%;
    }

    .header{
        width: 100%;
        height: 5em;
        display: flex;
        justify-content: space-between;
        box-shadow: 0 0 20px 5px gray;
        background: #fff;
        position: sticky;
        top:0;
        z-index: 10;
       position: -webkit-sticky;/*Safari用ベンダープレフィックス*/
    }

    .nav-but{

        position: sticky;
    }

    .navi-link{
        /*display:table-cell;*/
        
        
        width: 100%;
        height: 100%;
    }

    .navi-item:hover{
        /*background-color: rgba(var(--main-color),0.17);*/
        background-color: var(--sub-color);
        transition:0.3s ease-in-out;
    }
    
    /*下部ボタンーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー */

    .bottom-button{

         width: 100%;
        background: rgba(6,142,171,0.17);
        position: fixed;
        bottom: 0;
        padding: 15px 0;
        margin: 0 auto;
        text-align: center;
        background-blend-mode: multiply;
        z-index: 100;
        
    }
    .login-link{

        text-align: center;
        display: block;
        font-size:20px;
        margin: 0 auto;
        padding: 20px 35px;
        background: #068EAB;
        width: 250px;
        border-radius:20px ;
        font: #fff;
        border: solid 1.5px #fff;
        margin-right: 10px;
    }

    .booking-link{

        text-align: center;
        display: block;
        font-size:20px;
        margin: 0 auto;
        padding: 20px 35px;
        background: #FFE405;
        width: 250px;
        border-radius:20px ;
        font: #fff;
        border: solid 1.5px #fff;
        margin-left: 10px;
    }

    .login-link:visited{
        color:#fff;
    }

     .login-link:active{
        color:#fff;
    }

     .login-link:hover{
        color:#fff;
        opacity: 0.8;
        transition:  0.3s ease-in-out;
    }

    .booking-link:visited{
        color:#068EAB;
    }

     .booking-link:active{
        color:#068EAB;
    }

     .booking-link:hover{
        color:#068EAB;
        opacity: 0.8;
        transition:  0.3s ease-in-out;
    }

    .login-button,.booking-button{
        display: inline-block;
    }


    /* PC表示 */
    @media screen and (min-width:821px){
        .header{
            width: 100%;
            height: 5em;
            display: flex;
            justify-content: space-between;
            box-shadow: 0 0 20px 5px gray;
        }

        .logo-img{
            width: 10vw;
            margin: 10px;
        }

        .navi-list {
            display: flex;
            flex-wrap:nowrap;
            list-style: none;
            overflow: hidden;
            height: 100%;

            margin-right: 5vw;
        }

        .navi-item {
            color: var(--main-color);
            width:  10vw;
            text-align: center;

            background-color: white;
            height: 100%;
            
            /* 中央揃え用の調整 */
            display:flex;
            align-items: center;
            justify-content: center;
        }

        .navi-item-text{
            color: var(--main-color);
            width: 100%;
            height: 100%;
            text-align: center;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-content: center;
            /*display: inline-block;
            vertical-align: middle;*/
        }

        .navi-item-text-main{
            font-size: 1em;
            letter-spacing: 0.3em;
            margin-bottom: 0.6em;
            width: 100%;
        }

        .navi-item-text-sub{
            font-size: 0.1em;
            width: 100%;
        }
    }

    /* スマホ表示 */
    @media screen and (max-width:820px){
        .header{
            width: 100%;
            height: 3em;
            display: flex;
            /*justify-content: space-between;*/
            box-shadow: 0 0 20px 5px gray;
            
        }
        .logo-img{
            width: 10vw;
            /*height: 100%;*/
            margin: 2px;

            object-fit: contain;
            display: none;
        }
        nav{
            width: 100%;
        }
        .navi-list {
            display: flex;
            flex-wrap:nowrap;
            justify-content: space-around;
            list-style: none;
            overflow: hidden;
            height: 100%;

            /*margin-right: 5vw;*/
        }

        .navi-item {
            color: var(--main-color);
            width: 17%;
            /*min-width: 17%;*/
            text-align: center;

            background-color: white;
            height: 100%;
            
            /* 中央揃え用の調整 */
            display:flex;
            align-items: center;
            justify-content: center;

            flex: 1 0 auto;
        }

        .navi-item-text{
            color: var(--main-color);
            width: 100%;
            height: 100%;
            text-align: center;

            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-content: center;
        }

        .navi-item-text-main{
            font-size: 0.5em;
            letter-spacing: 0.3em;
            margin-bottom: 0.6em;
            width: 100%;
        }

        .navi-item-text-sub{
            font-size:10px;
            white-space: nowrap;

            /* 
                要素が小さいときに中央揃えに見えないので 
                幅をいじって無理やり中央揃えにする
            */
            width: 300%; 
            
            /* 縮小表示させて実質フォントサイズを小さくする */
            -webkit-transform:scale(0.5);
            -moz-transform:scale(0.5);
            -ms-transform:scale(0.5);
            -o-transform:scale(0.5);
            transform:scale(0.5);
        }

        .login-link,.booking-link{

            margin: 5px 0px;
            width: 150px;
            font-size: 12px;
            padding: 10px 10px;
            border-radius: 10px;
            margin: 0px 10px;
        
        }

        .bottom-button{

            padding: 8px 0;
        }
    }
</style>